import * as yup from 'yup';

// Optional: the leading `^$|` alternative lets an empty value pass so the user
// can skip the step, matching the desktop CompanyDetailsDE website rule.
export const websiteSchema = yup.object().shape({
  website: yup
    .string()
    .matches(
      /^$|((http|https):\/\/)?[a-zA-Z0-9./?:@\-_=#]+\.([a-zA-Z0-9&./?:@\-_=#])*/,
      'Bitte geben Sie eine gültige Webadresse an',
    ),
});
